import {AuthPageTemplateComponent} from './auth-page-template/auth-page-template.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomePageTemplateComponent} from './home-page-template/home-page-template.component';
import {AuthGuard} from '../guards/auth/auth.guard';
import {BelongToTheClinicGuard} from '../guards/belong-to-the-clinic/belong-to-the-clinic.guard';
import {HasActiveSubscriptionGuard} from '../guards/has-active-subscription/has-active-subscription.guard';
import {InnerPageTemplateComponent} from './inner-page-template/inner-page-template.component';
import {HasTokenGuard} from '../guards/has-token/has-token.guard';

const routes: Routes = [
  // RUTA TEPORAL POR NO PODER INGRESAR A LA PLATAFORMA
  {
    path: 'clinic/:clinicId/unregistered', component: InnerPageTemplateComponent,
    loadChildren: () => import('./../features/unregistered-patient/unregistered-patient.module').then(m => m.UnregisteredPatientModule)
  },
  // RUTAS PARA AUTH (LOGIN, REGISTER, OWNER, PATIENT, RECOVERY, TERMS)
  {
    path: 'auth', component: AuthPageTemplateComponent,
    loadChildren: () => import('./../features/auth/auth.module').then(m => m.AuthModule),
  },
  // RUTAS PARA ONBOARDING (ADMIN, PATIENT)
  {
    path: 'clinic/onboarding', component: AuthPageTemplateComponent,
    loadChildren: () => import('./../features/onboarding/onboarding.module').then(m => m.OnboardingModule),
    canActivateChild: []
  },
  // RUTAS PARA SUMMARY (EXPERT, PATIENT)
  {
    path: 'clinic/:clinicId/summary', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },
  // RUTAS PARA SOLICITUDES DE CITA
  {
    path: 'clinic/:clinicId/marketplace', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },
  // RUTAS PARA DASHBOARD (ESTADISTICAS)
  {
    path: 'clinic/:clinicId', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]//  , HasActiveSubscriptionGuard
  },
  // RUTAS PARA SELECCIONAR PLAN CUANDO SE VENCE (VER PLANES, VISTA DE CANCEL PLAN, VISTA DE DONE PLAN)
  {
    path: 'clinic/:clinicId/plans', component: InnerPageTemplateComponent,
    loadChildren: () => import('./../features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivateChild: [HasTokenGuard]
  },
  // RUTAS PARA VER PACIENTES (LISTA, DETALLES)
  {
    path: 'clinic/:clinicId/patients', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/patients/patients.module').then(m => m.PatientsModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },
  // RUTAS PARA ADMINISTRACION
  {
    path: 'clinic/:clinicId/administration', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/administration/administration.module').then(m => m.AdministrationModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },
  {
    path: 'clinic/:clinicId/calendar/:expertId', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/schedule/schedule.module').then(m => m.ScheduleModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },
  {
    path: 'clinic/:clinicId/food-groups', component: HomePageTemplateComponent,
    loadChildren: () => import('../features/food-groups/meal-plan.module').then(m => m.MealPlanModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },
  {
    path: 'clinic/:clinicId/meal-plans', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/meal-plans/meal-plans.module').then(m => m.MealPlansModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },


  // Expert Profile
  {
    path: 'clinic/:clinicId/profile/expert', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/expert-profile/expert-profile.module').then(m => m.ExpertProfileModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard]
  },

  // Patient Profile
  {
    path: 'clinic/:clinicId/profile/patient', component: HomePageTemplateComponent,
    loadChildren: () => import('./../features/user-profile/user-profile.module').then(m => m.UserProfileModule),
    canActivateChild: [AuthGuard, BelongToTheClinicGuard, HasActiveSubscriptionGuard],

  },
  {
    path: '**', redirectTo: 'auth/new/landing'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TemplatesRoutingModule { }
